import { gqlClient } from '@/api/graphql-client';
import estimateKeys from '@/api/queries/estimates/keyFactory';
import { graphql } from '@/gql';
import {
  EstimateCategory,
  RemoveEstimateDefaultItemMutation as RemoveEstimateDefaultItemMutationResult,
  Scalars,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const RemoveEstimateDefaultItemMutation = graphql(`
  mutation RemoveEstimateDefaultItem($id: ID!) {
    removeEstimateDefaultItem(id: $id)
  }
`);

type Variables = {
  id: Scalars['ID']['input'];
  category: EstimateCategory;
};

const useRemoveEstimateDefaultItem = (
  options?: UseMutationOptions<
    RemoveEstimateDefaultItemMutationResult,
    Error,
    Variables
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }) => {
      return gqlClient.request(RemoveEstimateDefaultItemMutation, { id });
    },
    onSettled: (_data, _error, variables) => {
      void queryClient.invalidateQueries({
        queryKey: estimateKeys.estimateDefaultItems(variables.category),
      });
    },
    ...options,
  });
};

export default useRemoveEstimateDefaultItem;
